import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Confetti from 'react-confetti'; // npm install react-confetti

const LiveEditor = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [code, setCode] = useState({
    hireable: "false",
    primaryColor: "#a855f7", // Purple
  });
  const [celebrate, setCelebrate] = useState(false);

  // Handle changes
  const handleChange = (key, value) => {
    setCode(prev => ({ ...prev, [key]: value }));

    // 1. Theme Color Injection (Jugad)
    if (key === 'primaryColor') {
      document.documentElement.style.setProperty('--neon-purple', value);
      document.documentElement.style.setProperty('--text-gradient', `linear-gradient(to right, ${value}, cyan)`);
    }

    // 2. Hireable Logic
    if (key === 'hireable' && value.trim() === 'true') {
      setCelebrate(true);
      setTimeout(() => setCelebrate(false), 5000); // 5 sec confetti
    }
  };

  return (
    <>
      {celebrate && <Confetti numberOfPieces={500} recycle={false} />}

      <motion.div
        initial={{ x: 100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ delay: 1 }}
        className="glass"
        style={{
          position: 'fixed',
          bottom: '30px',
          left: '30px',
          width: isOpen ? '300px' : '50px',
          height: isOpen ? 'auto' : '50px',
          background: 'rgba(15, 23, 42, 0.9)',
          border: '1px solid var(--neon-purple)',
          borderRadius: '15px',
          zIndex: 9999,
          overflow: 'hidden',
          fontFamily: 'Fira Code, monospace',
          boxShadow: '0 0 20px rgba(0,0,0,0.5)'
        }}
      >
        {/* Header / Toggle */}
        <div
          onClick={() => setIsOpen(!isOpen)}
          style={{
            padding: '10px',
            background: 'rgba(255,255,255,0.05)',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            color: '#94a3b8',
            fontSize: '0.8rem'
          }}
        >
          {/* <span>⚡</span> */}
          <span>{isOpen ? '▼' : '⚙️'}</span>
        </div>

        {/* The Editor */}
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ height: 0 }}
              animate={{ height: 'auto' }}
              exit={{ height: 0 }}
              style={{ padding: '15px' }}
            >
              <div style={{ marginBottom: '10px' }}>
                <span style={{ color: '#c678dd' }}>const</span> <span style={{ color: '#e5c07b' }}>User</span> = {'{'}
              </div>

              {/* Line 1: Hireable Status */}
              <div style={{ paddingLeft: '20px', marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
                <span style={{ color: '#e06c75', marginRight: '10px' }}>isHired:</span>
                <select
                  value={code.hireable}
                  onChange={(e) => handleChange('hireable', e.target.value)}
                  style={{
                    background: 'transparent',
                    color: code.hireable === 'true' ? '#98c379' : '#d19a66',
                    border: '1px solid #333',
                    borderRadius: '4px',
                    fontFamily: 'inherit',
                    cursor: 'pointer'
                  }}
                >
                  <option value="false">false</option>
                  <option value="true">true</option>
                </select>
              </div>

              {/* Line 2: Color Theme */}
              <div style={{ paddingLeft: '20px', marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
                <span style={{ color: '#61afef', marginRight: '10px' }}>themeColor:</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <span style={{ color: '#98c379' }}>"{code.primaryColor}"</span>
                  <input
                    type="color"
                    value={code.primaryColor}
                    onChange={(e) => handleChange('primaryColor', e.target.value)}
                    style={{
                      width: '20px',
                      height: '20px',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer'
                    }}
                  />
                </div>
              </div>

              <div>{'}'};</div>

              <div style={{ marginTop: '15px', fontSize: '0.75rem', color: '#5c6370', fontStyle: 'italic' }}>
                {/* Try changing these values! */}
              </div>

            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </>
  );
};

export default LiveEditor;